import { useMemo, useRef } from 'react';

import { differenceInDays } from 'date-fns';
import type { PersonalizationApiTraitData } from '@atlassian/jira-router-resources-recommendations/src/services/fetch-site-traits/types.tsx';
import { fetchSiteUserTraitsResource } from '@atlassian/jira-router-resources-recommendations/src/services/fetch-site-user-traits/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { parseAsTimestamp } from '../../common/date-utils.tsx';

export const JIRA_STANDARD_FEATURE_USAGE_TRAIT = 'jira_trial_standard_feature_last_used';
export const JIRA_PREMIUM_FEATURE_USAGE_TRAIT = 'jira_trial_premium_feature_last_used';

export const useHasUsedPremiumFeaturesRecently = (days: number): boolean | undefined => {
	const { data: traits, loading } = useResource<PersonalizationApiTraitData[] | null>(
		fetchSiteUserTraitsResource,
	);
	const now = useRef(Date.now());

	return useMemo(() => {
		if (!traits || loading) {
			return undefined;
		}

		const featureLastUsageTrait = traits.find(
			(trait) => trait?.name === JIRA_PREMIUM_FEATURE_USAGE_TRAIT,
		)?.value;
		const featureLastUsedTimestamp = parseAsTimestamp(featureLastUsageTrait);

		return typeof featureLastUsedTimestamp === 'number'
			? differenceInDays(now.current, featureLastUsedTimestamp) < days
			: false;
	}, [traits, days, loading]);
};
